import { CredentialItem } from './credential-item'

export class SuspensionCredentialItem extends CredentialItem {

  public constructor(data: any) {
    super({ ...data, rule: { display_name: 'Suspension' } })

    const { effective_at, expires_at } = this.credential

    this.validityLabel = `${this.getDate(effective_at)} - ${expires_at ? this.getDate(expires_at) : 'Indefinite'}`
    this.setStatusTag({ color: 'red', value: 'Suspended' })
  }

}
